import React from 'react';
import Group from '@spa/shared/components/Filters/Group';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';

const HIGH_RESPONSE_RATE = 80;
const MAX_RESPONSE_TIME = 12;

const Landlord = ({ fields, onChangeEventHandler }) => {
  const { t } = useTranslation('translations');

  return (
    <Group title={t('filters.sections.landlord')}>
      <CheckboxFilter
        name="instant-bookings"
        value="true"
        onChange={onChangeEventHandler}
        selected={fields['instant-bookings'] === 'true'}
        label={t('global.labels.instant_booking')}
      />
      <CheckboxFilter
        name="max-response-time"
        value={MAX_RESPONSE_TIME}
        onChange={onChangeEventHandler}
        selected={parseInt(fields['max-response-time'], 10) === MAX_RESPONSE_TIME}
        label={t('filters.labels.answers_within_12_hours')}
      />
      <CheckboxFilter
        name="min-response-rate"
        value={HIGH_RESPONSE_RATE}
        onChange={onChangeEventHandler}
        selected={parseInt(fields['min-response-rate'], 10) === HIGH_RESPONSE_RATE}
        label={t('filters.labels.high_response_rate')}
      />
      <CheckboxFilter
        name="has-resident-landlord"
        value={false}
        onChange={onChangeEventHandler}
        selected={fields['has-resident-landlord'] === 'false'}
        label={t('filters.labels.no_resident_landlord')}
      />
    </Group>
  );
};

Landlord.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired
};

export default Landlord;
